export default __webpack_public_path__ + "static/media/money.f2ad55b1.svg";